import { extractValueFromOrderTags } from '../orders/OrderTags';
import { DomainCoreGeneration } from '../libraries/DomainCoreGeneration';
const MY_GENERATION = DomainCoreGeneration.Generation5;
export const createAdditionalLines = (orderTags, options) => {
    const npsHash = Array.isArray(orderTags) && extractValueFromOrderTags('Nps', orderTags);
    const npsLine = {
        name: 'NPS',
        subLines: [],
        type: 'Meta',
        tags: [],
        generation: MY_GENERATION,
        values: [
            {
                type: 'Nps',
                npsHash: npsHash,
            },
        ],
    };
    const tableNumber = (options && options.tableNumber) || -1;
    const tableServingLine = {
        name: 'TABLE_SERVING',
        subLines: [],
        type: 'Meta',
        tags: [],
        generation: MY_GENERATION,
        values: [
            {
                type: 'TableServing',
                tableNumber,
            },
        ],
    };
    const deliveryOrderPrice = extractValueFromOrderTags('Delivery', orderTags);
    const delivery = deliveryOrderPrice.length !== 0
        ? {
            name: 'Delivery',
            subLines: [],
            type: 'Delivery',
            tags: ['Delivery'],
            generation: MY_GENERATION,
            totalPrice: +deliveryOrderPrice,
        }
        : null;
    const toAddInAdditionalLines = [npsLine, tableServingLine, delivery];
    const driveInBoothNumberConfig = (options && options.driveInBoothNumberConfig) || {
        onlinePosId: -1,
        boothNumber: -1,
    };
    const onlinePosId = +driveInBoothNumberConfig.onlinePosId;
    const boothNumber = +driveInBoothNumberConfig.boothNumber;
    if (onlinePosId !== -1 && boothNumber !== -1) {
        const boothNumberLine = {
            name: 'DRIVE_IN_DETAILS',
            subLines: [],
            type: 'Meta',
            tags: [],
            generation: MY_GENERATION,
            values: [
                {
                    type: 'DriveInDetails',
                    onlinePosId,
                    boothNumber,
                },
            ],
        };
        toAddInAdditionalLines.push(boothNumberLine);
    }
    return toAddInAdditionalLines.filter(Boolean);
};
